import { browser } from '$app/environment';
import { invalidate } from '$app/navigation';
import { supabase } from '$lib/supabase';

export const load = async ({ fetch }) => {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  // Set up auth state listener only in the browser
  if (browser) {
    supabase.auth.onAuthStateChange(() => {
      invalidate('supabase:auth');
    });
  }

  return {
    session: session,
  };
};
